export default "__VITE_ASSET__CKiRB2oU__"